import { useMemo } from 'react';
import Table from '../../../components/table';
import type { Event } from '../../../graphql/types';
import { tableData } from '../../../reports/data-events-table';

export type EventTableProps = {
  data?: Event[];
};

const EventsTable = ({ data }: EventTableProps) => {
  const eventData = useMemo(() => {
    if (!data) {
      return;
    }
    return tableData(data);
  }, [data]);

  if (!eventData) {
    return null;
  }

  return <Table {...eventData} />;
};

export { EventsTable };
